<template>
  <BaseModal
    name="сonsumptionBalanceTreeStepModal"
    width="420"
    :clickToClose="false"
    :shiftY="0.5"
    @before-close=""
    @before-open="loadData"
    :adaptive="true"
    height="auto"
    classes="tw-app-modal"
  >
    <div class="tw-app-modal__container">
      <BaseLoader v-if="localLoading" class="tw-rounded-[25px]"></BaseLoader>
      <button
        type="button"
        class="btn-close tw-app-modal__close"
        @click="$modal.hide('сonsumptionBalanceTreeStepModal')"
      ></button>

      <div class="tw-text-center">
        <div class="tw-app-modal__title">{{ dataLang["reg_company_38"] }}</div>

        <div>
          {{ dataLang["reg_company_39"] }}
        </div>

        <BaseInputNew
          inputClass="tw-app-input-type-3 tw-mt-[15px]"
          input-name="lastBillNumber"
          @input="updateValue"
          :horizontalTitle="true"
        >
        </BaseInputNew>

        <div class="tw-app-modal__footer">
          <button
            @click="$modal.hide('сonsumptionBalanceTreeStepModal')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            {{ dataLang["clients_register_text_96"] }}
          </button>
          <button
            @click="sendData"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
          >
            {{ dataLang["reg_company_24"] }}
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import GeneralService from "@/api/GeneralService.js";
import { VeTable } from "vue-easytable";

// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  props: {},
  data() {
    return {
      localLoading: false,
      dataForEmit: {},
      pincode: "",
      dataForModal: {
        minBalance: 0,
        companyIds: [],
        lastBillNumber: null,
      },
      currentId: null,
    };
  },
  methods: {
    loadData({ params }) {
      // this.pincode = params?.pincode
      this.dataForModal = Object.assign(this.dataForModal, params?.data);
      console.log(this.dataForModal);
    },
    beforeClose(event) {
      this.dataForEmit = {};
    },
    updateValue(data) {
      this.dataForEmit[data.name] = data.value;
      this.dataForModal[data.name] = data.value;
    },
    sendData() {
      if (this.dataForModal?.lastBillNumber) {
        this.localLoading = true;
        GeneralService.editOrCreate(
          `/super/companies/balance/out/step3?pincode=${this.pincode}`,
          this.dataForModal
        )
          .then((gege) => {
            console.log(gege);
            this.$toast.success(gege.data.message);
            this.$modal.show("consumptionBalanceFourStepModal", {
              ...this.dataForModal,
              documentId: gege.data.data.documentId,
            });
          })
          .catch((e) => {
            console.error(e);
            this.$toast.error(e.response.data.message, { duration: 5000 });
          })
          .finally(() => {
            this.$modal.hide("сonsumptionBalanceTreeStepModal");
            this.localLoading = false;
          });
      } else {
        this.$toast.error("Введите начальный номер", { duration: 5000 });
      }
    },
  },
  mounted() {},
  created() {
    GeneralService.get(
      `/settings?fields=company_settings__set_security_pass_for_forbidden`
    )
      .then((data) => {
        this.pincode =
          data.data.data.rows[0].company_settings__set_security_pass_for_forbidden;
      })
      .catch((e) => {});
  },
  beforeDestroy() {},

  computed: {
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
